(function () {
  /* =====================================================
     CONFIGURATION
     ===================================================== */

  const POLL_ID = '6aa2c25f08a73e70d38724e9';

  // CONFIGURATION FINALE
  const MIN_TIME = 60 * 1000;       // 60 secondes
  const MOBILE_IDLE = 20 * 1000;    // 20 secondes d'inactivité
  const SCROLL_THRESHOLD = 0.70;    // 70 % de la page

  const SEEN_KEY = 'zigpoll_friction_seen';
  const ATC_KEY = 'zigpoll_added_to_cart';

  let timeReached = false;
  let scrollReached = false;
  let opening = false;
  let idleTimer = null;

  const nativeFetch = window.fetch;

  const isMobile =
    window.matchMedia('(pointer: coarse)').matches ||
    window.matchMedia('(hover: none)').matches;


  /* =====================================================
     MÉMORISER TOUT AJOUT AU PANIER PENDANT LA SESSION
     ===================================================== */

  function markAddedToCart() {
    sessionStorage.setItem(ATC_KEY, '1');
  }

  // Ajout panier via formulaire Shopify classique
  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;

      if (
        form &&
        form.action &&
        form.action.includes('/cart/add')
      ) {
        markAddedToCart();
      }
    },
    true
  );

  // Ajout panier via fetch / AJAX
  if (nativeFetch) {
    window.fetch = function () {
      try {
        const request = arguments[0];

        const url =
          typeof request === 'string'
            ? request
            : request && request.url
              ? request.url
              : '';

        if (url.includes('/cart/add')) {
          markAddedToCart();
        }
      } catch (e) {}

      return nativeFetch.apply(this, arguments);
    };
  }

  // Ajout panier via XMLHttpRequest
  if (window.XMLHttpRequest) {
    const originalOpen = XMLHttpRequest.prototype.open;

    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (
          typeof url === 'string' &&
          url.includes('/cart/add')
        ) {
          markAddedToCart();
        }
      } catch (e) {}

      return originalOpen.apply(this, arguments);
    };
  }


  /* =====================================================
     UNIQUEMENT SUR LES FICHES PRODUIT
     ===================================================== */

  if (!window.location.pathname.includes('/products/')) {
    return;
  }

  // Déjà affiché pendant cette session
  if (sessionStorage.getItem(SEEN_KEY) === '1') {
    return;
  }

  // Le visiteur a déjà ajouté au panier pendant la session
  if (sessionStorage.getItem(ATC_KEY) === '1') {
    return;
  }


  /* =====================================================
     VÉRIFIER QUE LE PANIER EST VIDE
     ===================================================== */

  async function cartIsEmpty() {
    try {
      const response = await nativeFetch('/cart.js', {
        credentials: 'same-origin'
      });

      const cart = await response.json();

      if (cart.item_count > 0) {
        markAddedToCart();
        return false;
      }

      return true;
    } catch (e) {
      return false;
    }
  }


  /* =====================================================
     OUVRIR ZIGPOLL
     ===================================================== */

  function openZigpoll() {
    if (!window.Zigpoll) {
      return false;
    }

    window.Zigpoll.pollId = POLL_ID;

    const showSurvey = function () {
      sessionStorage.setItem(SEEN_KEY, '1');

      if (typeof window.Zigpoll.open === 'function') {
        window.Zigpoll.open();
      }
    };

    window.Zigpoll.onload = showSurvey;

    if (typeof window.Zigpoll.refresh === 'function') {
      window.Zigpoll.refresh();
      return true;
    }

    if (typeof window.Zigpoll.reload === 'function') {
      window.Zigpoll.reload();
      return true;
    }

    if (typeof window.Zigpoll.open === 'function') {
      showSurvey();
      return true;
    }

    return false;
  }


  async function triggerSurvey() {
    if (opening) return;

    if (!timeReached || !scrollReached) return;

    if (sessionStorage.getItem(SEEN_KEY) === '1') return;
    if (sessionStorage.getItem(ATC_KEY) === '1') return;

    opening = true;

    const empty = await cartIsEmpty();

    if (!empty) {
      opening = false;
      return;
    }

    let attempts = 0;

    const waitForZigpoll = setInterval(function () {
      attempts++;

      if (openZigpoll()) {
        clearInterval(waitForZigpoll);
        return;
      }

      if (attempts >= 100) {
        clearInterval(waitForZigpoll);
        opening = false;
      }
    }, 100);
  }


  /* =====================================================
     CONDITION 1 : MINIMUM 60 SECONDES
     ===================================================== */

  setTimeout(function () {
    timeReached = true;

    if (isMobile && scrollReached) {
      resetMobileIdleTimer();
    }
  }, MIN_TIME);


  /* =====================================================
     CONDITION 2 : AU MOINS 70 % DE SCROLL
     ===================================================== */

  function checkScrollDepth() {
    const maxScroll =
      document.documentElement.scrollHeight -
      window.innerHeight;

    if (maxScroll <= 0) return;

    const scrollPercentage =
      window.scrollY / maxScroll;

    if (
      !scrollReached &&
      scrollPercentage >= SCROLL_THRESHOLD
    ) {
      scrollReached = true;

      if (isMobile && timeReached) {
        resetMobileIdleTimer();
      }
    }
  }

  window.addEventListener(
    'scroll',
    checkScrollDepth,
    { passive: true }
  );

  checkScrollDepth();


  /* =====================================================
     DESKTOP : EXIT INTENT
     ===================================================== */

  if (!isMobile) {
    document.addEventListener('mouseout', function (event) {
      if (
        !event.relatedTarget &&
        event.clientY <= 10
      ) {
        triggerSurvey();
      }
    });
  }


  /* =====================================================
     MOBILE : 20 SECONDES D'INACTIVITÉ
     ===================================================== */

  function resetMobileIdleTimer() {
    if (!isMobile) return;

    if (!timeReached || !scrollReached) return;

    clearTimeout(idleTimer);

    idleTimer = setTimeout(function () {
      triggerSurvey();
    }, MOBILE_IDLE);
  }

  if (isMobile) {
    [
      'touchstart',
      'touchmove',
      'pointerdown',
      'click',
      'scroll'
    ].forEach(function (eventName) {
      window.addEventListener(
        eventName,
        resetMobileIdleTimer,
        { passive: true }
      );
    });
  }
})();